import React, { useState, useEffect } from 'react';
import './RecipeForm.css';

const RecipeForm = ({ recipe, onSubmit, onCancel }) => {
  const [title, setTitle] = useState('');
  const [calories, setCalories] = useState('');
  const [mealType, setMealType] = useState('desayuno');
  const [ingredients, setIngredients] = useState('');

  useEffect(() => {
    if (recipe) {
      setTitle(recipe.title || '');
      setCalories(recipe.calories || '');
      setMealType(recipe.meal_type || 'desayuno');
      setIngredients(recipe.ingredients || '');
    }
  }, [recipe]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const caloriesValue = calories === '' ? null : parseInt(calories);
    if (caloriesValue !== null && (caloriesValue < 0 || caloriesValue > 2000)) {
      alert('Las calorías deben estar entre 0 y 2000');
      return;
    }
    onSubmit({
      title,
      calories: caloriesValue,
      meal_type: mealType,
      ingredients,
    });
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{recipe ? 'Editar Receta' : 'Nueva Receta'}</h3>
          <button className="btn-close" onClick={onCancel}>✕</button>
        </div>
        <form onSubmit={handleSubmit} className="recipe-form">
          <div className="form-group">
            <label htmlFor="title">Título *</label>
            <input
              type="text"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              className="form-input"
            />
          </div>
          <div className="form-row">
            <div className="form-group form-group-half">
              <label htmlFor="mealType">Tipo de comida *</label>
              <select
                id="mealType"
                value={mealType}
                onChange={(e) => setMealType(e.target.value)}
                required
                className="form-input"
              >
                <option value="desayuno">Desayuno</option>
                <option value="almuerzo">Almuerzo</option>
                <option value="comida">Comida</option>
                <option value="cena">Cena</option>
              </select>
            </div>
            <div className="form-group form-group-half">
              <label htmlFor="calories">Calorías (máx. 2000)</label>
              <input
                type="number"
                id="calories"
                value={calories}
                onChange={(e) => setCalories(e.target.value)}
                min="0"
                max="2000"
                placeholder="Opcional"
                className="form-input"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="ingredients">Ingredientes (separados por punto y coma) *</label>
            <textarea
              id="ingredients"
              value={ingredients}
              onChange={(e) => setIngredients(e.target.value)}
              required
              placeholder="Ej: 200gr de gambas; 250gr de patatas; 1 cuch aceite oliva"
              className="form-textarea"
              rows={4}
            />
          </div>
          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={onCancel}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary">
              {recipe ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RecipeForm;

